// // // // // import React, { createContext, useContext, useEffect, useState } from "react";
// // // // // import { io } from "socket.io-client";

// // // // // const WebSocketContext = createContext();

// // // // // export const WebSocketProvider = ({ children }) => {
// // // // //   const [socket, setSocket] = useState(null);

// // // // //   useEffect(() => {
// // // // //     // Replace with your WebSocket server URL
// // // // //     const socketInstance = io(`${process.env.REACT_APP_CURRENT_URL}`);

// // // // //     setSocket(socketInstance);

// // // // //     // Cleanup on unmount
// // // // //     return () => {
// // // // //       socketInstance.disconnect();
// // // // //     };
// // // // //   }, []);

// // // // //   return (
// // // // //     <WebSocketContext.Provider value={socket}>
// // // // //       {children}
// // // // //     </WebSocketContext.Provider>
// // // // //   );
// // // // // };

// // // // // export const useWebSocket = () => {
// // // // //   return useContext(WebSocketContext);
// // // // // };
// // // // import React, {
// // // //   createContext,
// // // //   useContext,
// // // //   useEffect,
// // // //   useState,
// // // //   useCallback,
// // // //   useRef,
// // // // } from "react";
// // // // import { useSelector } from "react-redux";

// // // // const WebSocketContext = createContext();

// // // // /**
// // // //  * Enhanced WebSocket Provider with:
// // // //  * - Automatic reconnection with exponential backoff
// // // //  * - Heartbeat mechanism
// // // //  * - Message queuing for offline messages
// // // //  * - Connection state management
// // // //  * - Message acknowledgment system
// // // //  */
// // // // export const WebSocketProvider = ({ children }) => {
// // // //   const [connections, setConnections] = useState(new Map()); // Store multiple WebSocket connections
// // // //   const [connectionStates, setConnectionStates] = useState(new Map());
// // // //   const reconnectAttemptsRef = useRef(new Map());
// // // //   const reconnectTimersRef = useRef(new Map());
// // // //   const heartbeatIntervalsRef = useRef(new Map());
// // // //   const messageQueuesRef = useRef(new Map());
// // // //   const pendingMessagesRef = useRef(new Map());
// // // //   const user_id = useSelector((state) => state.user.user_id);

// // // //   const MAX_RECONNECT_ATTEMPTS = 5;
// // // //   const INITIAL_RECONNECT_DELAY = 1000; // 1 second
// // // //   const MAX_RECONNECT_DELAY = 30000; // 30 seconds
// // // //   const HEARTBEAT_INTERVAL = 30000; // 30 seconds

// // // //   /**
// // // //    * Calculate reconnection delay with exponential backoff
// // // //    */
// // // //   const getReconnectDelay = (attempts) => {
// // // //     const delay = Math.min(
// // // //       INITIAL_RECONNECT_DELAY * Math.pow(2, attempts),
// // // //       MAX_RECONNECT_DELAY
// // // //     );
// // // //     return delay;
// // // //   };

// // // //   /**
// // // //    * Create or get existing WebSocket connection
// // // //    */
// // // //   const createConnection = useCallback(
// // // //     (roomName, studentId, config = {}) => {
// // // //       const key = `${roomName}_${studentId}`;

// // // //       // Return existing connection if available and open
// // // //       const existingConnection = connections.get(key);
// // // //       if (
// // // //         existingConnection &&
// // // //         existingConnection.readyState === WebSocket.OPEN
// // // //       ) {
// // // //         return existingConnection;
// // // //       }

// // // //       // Close existing connection if it exists but not open
// // // //       if (existingConnection) {
// // // //         try {
// // // //           existingConnection.close();
// // // //         } catch (e) {
// // // //           console.error("Error closing existing connection:", e);
// // // //         }
// // // //       }

// // // //       const wsUrl = `${
// // // //         process.env.REACT_APP_WS_URL || "ws://localhost:8000"
// // // //       }/ws/chat/${roomName}/${studentId}/`;
// // // //       console.log(`Creating WebSocket connection to: ${wsUrl}`);

// // // //       const ws = new WebSocket(wsUrl);

// // // //       // Initialize connection state
// // // //       setConnectionStates((prev) =>
// // // //         new Map(prev).set(key, {
// // // //           status: "connecting",
// // // //           lastConnected: null,
// // // //           error: null,
// // // //         })
// // // //       );

// // // //       // Initialize message queue
// // // //       if (!messageQueuesRef.current.has(key)) {
// // // //         messageQueuesRef.current.set(key, []);
// // // //       }

// // // //       ws.onopen = () => {
// // // //         console.log(`WebSocket connected: ${key}`);

// // // //         setConnectionStates((prev) =>
// // // //           new Map(prev).set(key, {
// // // //             status: "connected",
// // // //             lastConnected: new Date(),
// // // //             error: null,
// // // //           })
// // // //         );

// // // //         // Reset reconnect attempts
// // // //         reconnectAttemptsRef.current.set(key, 0);

// // // //         // Clear reconnect timer
// // // //         const timer = reconnectTimersRef.current.get(key);
// // // //         if (timer) {
// // // //           clearTimeout(timer);
// // // //           reconnectTimersRef.current.delete(key);
// // // //         }

// // // //         // Start heartbeat
// // // //         startHeartbeat(key, ws);

// // // //         // Send queued messages
// // // //         sendQueuedMessages(key, ws);

// // // //         // Call custom onOpen handler
// // // //         if (config.onOpen) {
// // // //           config.onOpen();
// // // //         }
// // // //       };

// // // //       ws.onmessage = (event) => {
// // // //         try {
// // // //           const data = JSON.parse(event.data);

// // // //           // Handle different message types
// // // //           switch (data.type) {
// // // //             case "connection_established":
// // // //               console.log(`Connection established for room: ${key}`);
// // // //               break;

// // // //             case "message":
// // // //             case "history_message":
// // // //               // Regular message
// // // //               if (config.onMessage) {
// // // //                 config.onMessage(data);
// // // //               }
// // // //               break;

// // // //             case "history_complete":
// // // //               console.log(`Loaded ${data.count} historical messages`);
// // // //               if (config.onHistoryComplete) {
// // // //                 config.onHistoryComplete(data);
// // // //               }
// // // //               break;

// // // //             case "message_sent":
// // // //               // Delivery confirmation
// // // //               handleDeliveryConfirmation(key, data);
// // // //               break;

// // // //             case "error":
// // // //               console.error("Server error:", data.error);
// // // //               if (config.onError) {
// // // //                 config.onError(data.error);
// // // //               }
// // // //               break;

// // // //             case "heartbeat":
// // // //               // Respond to heartbeat
// // // //               sendPong(ws);
// // // //               break;

// // // //             case "pong":
// // // //               // Heartbeat response received
// // // //               break;

// // // //             default:
// // // //               console.log("Unknown message type:", data.type);
// // // //           }
// // // //         } catch (error) {
// // // //           console.error("Error parsing WebSocket message:", error);
// // // //         }
// // // //       };

// // // //       ws.onerror = (error) => {
// // // //         console.error(`WebSocket error for ${key}:`, error);

// // // //         setConnectionStates((prev) =>
// // // //           new Map(prev).set(key, {
// // // //             status: "error",
// // // //             lastConnected: prev.get(key)?.lastConnected || null,
// // // //             error: "Connection error",
// // // //           })
// // // //         );

// // // //         if (config.onError) {
// // // //           config.onError(error);
// // // //         }
// // // //       };

// // // //       ws.onclose = (event) => {
// // // //         console.log(
// // // //           `WebSocket closed for ${key}. Code: ${event.code}, Reason: ${event.reason}`
// // // //         );

// // // //         // Stop heartbeat
// // // //         const heartbeatInterval = heartbeatIntervalsRef.current.get(key);
// // // //         if (heartbeatInterval) {
// // // //           clearInterval(heartbeatInterval);
// // // //           heartbeatIntervalsRef.current.delete(key);
// // // //         }

// // // //         setConnectionStates((prev) =>
// // // //           new Map(prev).set(key, {
// // // //             status: "disconnected",
// // // //             lastConnected: prev.get(key)?.lastConnected || null,
// // // //             error: event.reason || "Connection closed",
// // // //           })
// // // //         );

// // // //         // Attempt reconnection if not a normal closure
// // // //         if (event.code !== 1000) {
// // // //           attemptReconnect(key, roomName, studentId, config);
// // // //         }

// // // //         if (config.onClose) {
// // // //           config.onClose(event);
// // // //         }
// // // //       };

// // // //       // Store connection
// // // //       setConnections((prev) => new Map(prev).set(key, ws));

// // // //       return ws;
// // // //     },
// // // //     [connections]
// // // //   );

// // // //   /**
// // // //    * Attempt to reconnect with exponential backoff
// // // //    */
// // // //   const attemptReconnect = (key, roomName, studentId, config) => {
// // // //     const attempts = reconnectAttemptsRef.current.get(key) || 0;

// // // //     if (attempts >= MAX_RECONNECT_ATTEMPTS) {
// // // //       console.error(`Max reconnection attempts reached for ${key}`);
// // // //       setConnectionStates((prev) =>
// // // //         new Map(prev).set(key, {
// // // //           status: "failed",
// // // //           lastConnected: prev.get(key)?.lastConnected || null,
// // // //           error: "Max reconnection attempts reached",
// // // //         })
// // // //       );
// // // //       return;
// // // //     }

// // // //     const delay = getReconnectDelay(attempts);
// // // //     console.log(
// // // //       `Attempting to reconnect ${key} in ${delay}ms (attempt ${
// // // //         attempts + 1
// // // //       }/${MAX_RECONNECT_ATTEMPTS})`
// // // //     );

// // // //     reconnectAttemptsRef.current.set(key, attempts + 1);

// // // //     const timer = setTimeout(() => {
// // // //       createConnection(roomName, studentId, config);
// // // //     }, delay);

// // // //     reconnectTimersRef.current.set(key, timer);
// // // //   };

// // // //   /**
// // // //    * Start heartbeat to keep connection alive
// // // //    */
// // // //   const startHeartbeat = (key, ws) => {
// // // //     const interval = setInterval(() => {
// // // //       if (ws.readyState === WebSocket.OPEN) {
// // // //         ws.send(JSON.stringify({ type: "ping" }));
// // // //       }
// // // //     }, HEARTBEAT_INTERVAL);

// // // //     heartbeatIntervalsRef.current.set(key, interval);
// // // //   };

// // // //   /**
// // // //    * Send pong response to heartbeat
// // // //    */
// // // //   const sendPong = (ws) => {
// // // //     if (ws.readyState === WebSocket.OPEN) {
// // // //       ws.send(JSON.stringify({ type: "pong" }));
// // // //     }
// // // //   };

// // // //   /**
// // // //    * Send message with retry logic
// // // //    */
// // // //   const sendMessage = useCallback(
// // // //     (roomName, studentId, message) => {
// // // //       const key = `${roomName}_${studentId}`;
// // // //       const ws = connections.get(key);

// // // //       // Generate client message ID for deduplication
// // // //       const clientMessageId = `${user_id}_${Date.now()}_${Math.random()
// // // //         .toString(36)
// // // //         .substr(2, 9)}`;

// // // //       const messageData = {
// // // //         type: "chat_message",
// // // //         ...message,
// // // //         client_message_id: clientMessageId,
// // // //         sender_id: user_id,
// // // //       };

// // // //       // Store in pending messages
// // // //       if (!pendingMessagesRef.current.has(key)) {
// // // //         pendingMessagesRef.current.set(key, new Map());
// // // //       }
// // // //       pendingMessagesRef.current.get(key).set(clientMessageId, {
// // // //         message: messageData,
// // // //         timestamp: Date.now(),
// // // //         attempts: 0,
// // // //       });

// // // //       if (ws && ws.readyState === WebSocket.OPEN) {
// // // //         ws.send(JSON.stringify(messageData));
// // // //         return clientMessageId;
// // // //       } else {
// // // //         // Queue message if not connected
// // // //         console.log(`WebSocket not connected for ${key}. Queuing message.`);
// // // //         const queue = messageQueuesRef.current.get(key) || [];
// // // //         queue.push(messageData);
// // // //         messageQueuesRef.current.set(key, queue);

// // // //         // Trigger reconnection if needed
// // // //         if (!ws || ws.readyState === WebSocket.CLOSED) {
// // // //           const [room, student] = key.split("_");
// // // //           createConnection(room, student, {});
// // // //         }

// // // //         return clientMessageId;
// // // //       }
// // // //     },
// // // //     [connections, user_id]
// // // //   );

// // // //   /**
// // // //    * Send acknowledgment for received message
// // // //    */
// // // //   const sendAcknowledgment = useCallback(
// // // //     (roomName, studentId, messageId) => {
// // // //       const key = `${roomName}_${studentId}`;
// // // //       const ws = connections.get(key);

// // // //       if (ws && ws.readyState === WebSocket.OPEN) {
// // // //         ws.send(
// // // //           JSON.stringify({
// // // //             type: "ack",
// // // //             message_id: messageId,
// // // //           })
// // // //         );
// // // //       }
// // // //     },
// // // //     [connections]
// // // //   );

// // // //   /**
// // // //    * Handle delivery confirmation from server
// // // //    */
// // // //   const handleDeliveryConfirmation = (key, data) => {
// // // //     const { client_message_id, status } = data;
// // // //     const pending = pendingMessagesRef.current.get(key);

// // // //     if (pending && pending.has(client_message_id)) {
// // // //       if (status === "delivered") {
// // // //         pending.delete(client_message_id);
// // // //         console.log(`Message ${client_message_id} delivered successfully`);
// // // //       }
// // // //     }
// // // //   };

// // // //   /**
// // // //    * Send queued messages when connection is established
// // // //    */
// // // //   const sendQueuedMessages = (key, ws) => {
// // // //     const queue = messageQueuesRef.current.get(key) || [];

// // // //     if (queue.length > 0) {
// // // //       console.log(`Sending ${queue.length} queued messages for ${key}`);

// // // //       queue.forEach((message) => {
// // // //         if (ws.readyState === WebSocket.OPEN) {
// // // //           ws.send(JSON.stringify(message));
// // // //         }
// // // //       });

// // // //       // Clear queue
// // // //       messageQueuesRef.current.set(key, []);
// // // //     }
// // // //   };

// // // //   /**
// // // //    * Close specific connection
// // // //    */
// // // //   const closeConnection = useCallback(
// // // //     (roomName, studentId) => {
// // // //       const key = `${roomName}_${studentId}`;
// // // //       const ws = connections.get(key);

// // // //       if (ws) {
// // // //         // Stop heartbeat
// // // //         const heartbeatInterval = heartbeatIntervalsRef.current.get(key);
// // // //         if (heartbeatInterval) {
// // // //           clearInterval(heartbeatInterval);
// // // //           heartbeatIntervalsRef.current.delete(key);
// // // //         }

// // // //         // Clear reconnect timer
// // // //         const timer = reconnectTimersRef.current.get(key);
// // // //         if (timer) {
// // // //           clearTimeout(timer);
// // // //           reconnectTimersRef.current.delete(key);
// // // //         }

// // // //         // Close WebSocket
// // // //         ws.close(1000, "Client closed connection");

// // // //         // Clean up
// // // //         setConnections((prev) => {
// // // //           const newMap = new Map(prev);
// // // //           newMap.delete(key);
// // // //           return newMap;
// // // //         });

// // // //         setConnectionStates((prev) => {
// // // //           const newMap = new Map(prev);
// // // //           newMap.delete(key);
// // // //           return newMap;
// // // //         });

// // // //         reconnectAttemptsRef.current.delete(key);
// // // //         messageQueuesRef.current.delete(key);
// // // //         pendingMessagesRef.current.delete(key);
// // // //       }
// // // //     },
// // // //     [connections]
// // // //   );

// // // //   /**
// // // //    * Get connection state
// // // //    */
// // // //   const getConnectionState = useCallback(
// // // //     (roomName, studentId) => {
// // // //       const key = `${roomName}_${studentId}`;
// // // //       return (
// // // //         connectionStates.get(key) || {
// // // //           status: "disconnected",
// // // //           lastConnected: null,
// // // //           error: null,
// // // //         }
// // // //       );
// // // //     },
// // // //     [connectionStates]
// // // //   );

// // // //   /**
// // // //    * Cleanup on unmount
// // // //    */
// // // //   useEffect(() => {
// // // //     return () => {
// // // //       // Close all connections
// // // //       connections.forEach((ws, key) => {
// // // //         try {
// // // //           ws.close(1000, "Component unmounted");
// // // //         } catch (e) {
// // // //           console.error(`Error closing connection ${key}:`, e);
// // // //         }
// // // //       });

// // // //       // Clear all intervals
// // // //       heartbeatIntervalsRef.current.forEach((interval) => {
// // // //         clearInterval(interval);
// // // //       });

// // // //       // Clear all timers
// // // //       reconnectTimersRef.current.forEach((timer) => {
// // // //         clearTimeout(timer);
// // // //       });
// // // //     };
// // // //   }, [connections]);

// // // //   const value = {
// // // //     createConnection,
// // // //     closeConnection,
// // // //     sendMessage,
// // // //     sendAcknowledgment,
// // // //     getConnectionState,
// // // //     connections,
// // // //     connectionStates,
// // // //   };

// // // //   return (
// // // //     <WebSocketContext.Provider value={value}>
// // // //       {children}
// // // //     </WebSocketContext.Provider>
// // // //   );
// // // // };

// // // // export const useWebSocket = () => {
// // // //   const context = useContext(WebSocketContext);
// // // //   if (!context) {
// // // //     throw new Error("useWebSocket must be used within WebSocketProvider");
// // // //   }
// // // //   return context;
// // // // };

// // // // export default WebSocketProvider;
// // // import React, { createContext, useContext, useRef } from "react";
// // // import { io } from "socket.io-client";

// // // const WebSocketContext = createContext();
// // // export const useWebSocket = () => useContext(WebSocketContext);

// // // const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || "http://localhost:5000";

// // // export function WebSocketProvider({ children }) {
// // //   const sockets = useRef({});
// // //   const listeners = useRef({});

// // //   // ------------------------------------------------------------
// // //   // JOIN ROOM
// // //   // ------------------------------------------------------------
// // //   const createConnection = (roomKey, studentId, callbacks = {}) => {
// // //     if (!roomKey || !studentId) return;

// // //     const roomname = `${roomKey}_${studentId}`;

// // //     console.log("🔌 Joining room:", roomname);

// // //     if (!sockets.current[roomname]) {
// // //       const socket = io(SOCKET_URL, {
// // //         transports: ["websocket"],
// // //         reconnection: true,
// // //       });

// // //       sockets.current[roomname] = socket;

// // //       // HISTORY + MESSAGE LISTENERS
// // //       socket.on("history_message", (msg) => {
// // //         callbacks.onMessage?.(msg);
// // //       });

// // //       socket.on("history_complete", () => {
// // //         callbacks.onHistoryComplete?.();
// // //       });

// // //       socket.on("receive_message", (msg) => {
// // //         callbacks.onMessage?.(msg);
// // //       });

// // //       socket.on("connect", () => console.log("🟢 Connected:", roomname));
// // //       socket.on("disconnect", () => console.log("🔴 Disconnected:", roomname));

// // //       // Finally join
// // //       socket.emit("join_room", { roomname, user_id: studentId });
// // //     }
// // //   };

// // //   // ------------------------------------------------------------
// // //   // LEAVE ROOM
// // //   // ------------------------------------------------------------
// // //   const closeConnection = (roomKey, studentId) => {
// // //     if (!roomKey || !studentId) return;

// // //     const roomname = `${roomKey}_${studentId}`;
// // //     const socket = sockets.current[roomname];
// // //     if (!socket) return;

// // //     console.log("🚪 Leaving room:", roomname);

// // //     socket.emit("leave_room", roomname);
// // //     socket.disconnect();
// // //     delete sockets.current[roomname];
// // //   };

// // //   // ------------------------------------------------------------
// // //   // SEND MESSAGE
// // //   // ------------------------------------------------------------
// // //   const sendMessage = (roomKey, studentId, payload) => {
// // //     const roomname = `${roomKey}_${studentId}`;
// // //     const socket = sockets.current[roomname];

// // //     if (!socket) {
// // //       console.error("❌ Cannot send — socket not connected for", roomname);
// // //       return;
// // //     }

// // //     socket.emit("send_message", {
// // //       ...payload,
// // //       roomname,
// // //     });
// // //   };

// // //   return (
// // //     <WebSocketContext.Provider
// // //       value={{
// // //         createConnection,
// // //         closeConnection,
// // //         sendMessage,
// // //       }}
// // //     >
// // //       {children}
// // //     </WebSocketContext.Provider>
// // //   );
// // // }
// // import React, { createContext, useContext, useRef } from "react";
// // import { io } from "socket.io-client";

// // const WebSocketContext = createContext();
// // export const useWebSocket = () => useContext(WebSocketContext);

// // const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || "http://localhost:5000";

// // export function WebSocketProvider({ children }) {
// //   const sockets = useRef({});

// //   // ------------------------------------------------------------
// //   // JOIN ROOM
// //   // ------------------------------------------------------------
// //   const createConnection = (roomKey, studentId, callbacks = {}) => {
// //     if (!roomKey || !studentId) return;

// //     const roomname = `${roomKey}_${studentId}`;
// //     console.log("🔌 Joining room:", roomname);

// //     // If already connected → do nothing
// //     if (sockets.current[roomname]) {
// //       console.log("⚠️ Socket already exists for", roomname);
// //       return;
// //     }

// //     // Create socket instance
// //     const socket = io(SOCKET_URL, {
// //       transports: ["websocket"],
// //       reconnection: true,
// //     });

// //     sockets.current[roomname] = socket;

// //     // ---------------------------
// //     // HISTORY EVENT LISTENERS
// //     // ---------------------------
// //     socket.on("history_message", (msg) => {
// //       console.log("📜 HISTORY:", msg);
// //       callbacks.onMessage?.(msg);
// //     });

// //     socket.on("history_complete", () => {
// //       console.log("📘 HISTORY COMPLETE");
// //       callbacks.onHistoryComplete?.();
// //     });

// //     // ---------------------------
// //     // REALTIME MESSAGE LISTENER
// //     // ---------------------------
// //     socket.on("message", (msg) => {
// //       console.log("💬 REALTIME MESSAGE:", msg);
// //       callbacks.onMessage?.(msg);
// //     });

// //     // ---------------------------
// //     // CONNECTION EVENTS
// //     // ---------------------------
// //     socket.on("connect", () => console.log("🟢 Connected:", roomname));
// //     socket.on("disconnect", () => console.log("🔴 Disconnected:", roomname));

// //     // Join the room
// //     socket.emit("join_room", { roomname, user_id: studentId });
// //   };

// //   // ------------------------------------------------------------
// //   // LEAVE ROOM
// //   // ------------------------------------------------------------
// //   const closeConnection = (roomKey, studentId) => {
// //     if (!roomKey || !studentId) return;

// //     const roomname = `${roomKey}_${studentId}`;
// //     const socket = sockets.current[roomname];
// //     if (!socket) return;

// //     console.log("🚪 Leaving room:", roomname);

// //     socket.emit("leave_room", roomname);
// //     socket.disconnect();

// //     delete sockets.current[roomname];
// //   };

// //   // ------------------------------------------------------------
// //   // SEND MESSAGE
// //   // ------------------------------------------------------------
// //   const sendMessage = (roomKey, studentId, payload) => {
// //     const roomname = `${roomKey}_${studentId}`;
// //     const socket = sockets.current[roomname];

// //     if (!socket) {
// //       console.error("❌ Cannot send — socket not connected for", roomname);
// //       return;
// //     }

// //     console.log("📤 Sending message to room:", roomname);

// //     socket.emit("send_message", {
// //       ...payload,
// //       roomname,
// //     });
// //   };

// //   return (
// //     <WebSocketContext.Provider
// //       value={{
// //         createConnection,
// //         closeConnection,
// //         sendMessage,
// //       }}
// //     >
// //       {children}
// //     </WebSocketContext.Provider>
// //   );
// // }
// import React, { createContext, useContext, useRef } from "react";
// import { io } from "socket.io-client";
// import axios from "axios";

// const WebSocketContext = createContext();
// export const useWebSocket = () => useContext(WebSocketContext);

// // -----------------------------------------------
// // CONFIG
// // -----------------------------------------------
// const SOCKET_URL = process.env.REACT_APP_BASE_URL || "http://localhost:5000";
// const API_GET_MESSAGES = "/chat_app/getmessages/";

// export function WebSocketProvider({ children }) {
//   const token = localStorage.getItem("token");

//   const sockets = useRef({});
//   const roomCallbacks = useRef({});

//   // ------------------------------------------------------------
//   // CREATE / JOIN ROOM
//   // ------------------------------------------------------------
//   const createConnection = async (roomKey, studentId, callbacks = {}) => {
//     if (!roomKey || !studentId) return;

//     const roomname = `${roomKey}_${studentId}`;
//     console.log("🔌 Opening room:", roomname);

//     // Save callbacks for this room
//     roomCallbacks.current[roomname] = callbacks;

//     // Prevent duplicate sockets
//     if (sockets.current[roomname]) {
//       console.log("⚠️ Room already active:", roomname);
//       return;
//     }

//     // -----------------------------
//     // 1️⃣ CREATE SOCKET
//     // -----------------------------
//     const socket = io(SOCKET_URL, {
//       transports: ["websocket"],
//       reconnection: true,
//       reconnectionAttempts: Infinity,
//       reconnectionDelay: 800,
//     });

//     sockets.current[roomname] = socket;

//     // -----------------------------
//     // 2️⃣ SOCKET EVENTS
//     // -----------------------------
//     socket.on("connect", () => {
//       console.log("🟢 Connected:", roomname);

//       socket.emit("join_room", {
//         roomname,
//         user_id: callbacks.userId,
//       });
//     });

//     socket.on("disconnect", () => {
//       console.log("🔴 Disconnected:", roomname);
//     });

//     // Live incoming messages
//     socket.on("message", (msg) => {
//       roomCallbacks.current[roomname]?.onMessage?.(msg);
//     });

//     // History via WebSocket (IF backend sends)
//     socket.on("history_message", (msg) => {
//       roomCallbacks.current[roomname]?.onMessage?.(msg);
//     });

//     socket.on("history_complete", () => {
//       console.log("📘 Socket history complete:", roomname);
//       roomCallbacks.current[roomname]?.onHistoryComplete?.();
//     });

//     socket.on("message_failed", (err) => {
//       roomCallbacks.current[roomname]?.onMessageFailed?.(err);
//     });

//     // -----------------------------
//     // 3️⃣ LOAD HISTORY FROM DJANGO API
//     // -----------------------------
//     try {
//       const response = await axios.get(`${SOCKET_URL}${API_GET_MESSAGES}`, {
//         params: { room: roomname, limit: 500 },
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       });

//       const history = response.data.messages || [];
//       console.log(`📥 REST History loaded (${history.length}) →`, roomname);

//       history.forEach((m) => roomCallbacks.current[roomname]?.onMessage?.(m));

//       roomCallbacks.current[roomname]?.onHistoryComplete?.();
//     } catch (err) {
//       console.error("❌ REST history error:", err);
//     }
//   };

//   // ------------------------------------------------------------
//   // CLOSE / LEAVE ROOM
//   // ------------------------------------------------------------
//   const closeConnection = (roomKey, studentId) => {
//     if (!roomKey || !studentId) return;

//     const roomname = `${roomKey}_${studentId}`;
//     const socket = sockets.current[roomname];

//     if (!socket) return;

//     console.log("🚪 Closing socket:", roomname);

//     socket.removeAllListeners();
//     socket.disconnect();

//     delete sockets.current[roomname];
//     delete roomCallbacks.current[roomname];
//   };

//   // ------------------------------------------------------------
//   // SEND MESSAGE
//   // ------------------------------------------------------------
//   const sendMessage = (roomKey, studentId, payload) => {
//     const roomname = `${roomKey}_${studentId}`;
//     const socket = sockets.current[roomname];

//     if (!socket) {
//       console.error("❌ Cannot send, socket not connected:", roomname);
//       return;
//     }

//     const data = {
//       ...payload,
//       roomname,
//     };

//     console.log("📤 send_message:", data);
//     socket.emit("send_message", data);
//   };

//   return (
//     <WebSocketContext.Provider
//       value={{
//         createConnection,
//         closeConnection,
//         sendMessage,
//       }}
//     >
//       {children}
//     </WebSocketContext.Provider>
//   );
// }
import React, { createContext, useContext, useRef, useEffect } from "react";
import { io } from "socket.io-client";

const WebSocketContext = createContext();

export const useWebSocket = () => {
  const context = useContext(WebSocketContext);
  if (!context) {
    throw new Error("useWebSocket must be used within WebSocketProvider");
  }
  return context;
};

// ⚠️ IMPORTANT: Use HTTP URL, not WS URL for Socket.IO
// Socket.IO will handle the WebSocket upgrade internally
const SOCKET_URL =
  process.env.REACT_APP_WEB_SOCKET_URL ||
  process.env.REACT_APP_BASE_URL ||
  "http://localhost:5000";

export function WebSocketProvider({ children }) {
  const sockets = useRef({});
  const roomCallbacks = useRef({});

  // ------------------------------------------------------------
  // CREATE / JOIN ROOM
  // ------------------------------------------------------------
  const createConnection = (roomKey, studentId, callbacks = {}) => {
    if (!roomKey || !studentId) {
      console.error("❌ roomKey and studentId are required");
      return;
    }

    // Format room name consistently: "cv_upload_123"
    const roomname = `${roomKey}_${studentId}`;

    console.log("📌 Attempting connection...");
    console.log("   - Socket URL:", SOCKET_URL);
    console.log("   - Room name:", roomname);
    console.log("   - Room key:", roomKey);
    console.log("   - Student ID:", studentId);

    // Save callbacks for this room
    roomCallbacks.current[roomname] = callbacks;

    // Prevent duplicate sockets
    if (sockets.current[roomname]) {
      console.log("⚠️ Room already active:", roomname);
      return;
    }

    // -----------------------------
    // CREATE SOCKET
    // -----------------------------
    console.log("🔌 Creating Socket.IO connection...");

    // Get auth token from localStorage
    const token = localStorage.getItem("token");

    if (!token) {
      console.warn("⚠️ No auth token found in localStorage");
    } else {
      console.log("🔐 Auth token found, sending with connection");
    }

    const socket = io(SOCKET_URL, {
      path: "/socket.io/",
      transports: ["websocket", "polling"],
      reconnection: true,
      reconnectionAttempts: 5,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 5000,
      timeout: 10000,
      auth: {
        token: token,
      },
      query: {
        token: token,
      },
    });

    sockets.current[roomname] = socket;

    console.log("📡 Socket instance created, waiting for connection...");

    // -----------------------------
    // SOCKET EVENTS
    // -----------------------------
    socket.on("connect", () => {
      console.log("✅ Socket.IO connected successfully!");
      console.log("   - Socket ID:", socket.id);
      console.log("   - Transport:", socket.io.engine.transport.name);
      console.log("   - Connected:", socket.connected);

      // Join room on server
      console.log("📨 Emitting join_room event...");
      socket.emit("join_room", {
        roomname,
        user_id: callbacks.userId || "unknown",
      });
      console.log("✅ join_room event emitted");
    });

    socket.on("disconnect", (reason) => {
      console.log("🔴 Disconnected:", roomname, "Reason:", reason);

      if (callbacks.onDisconnect) {
        callbacks.onDisconnect(reason);
      }
    });

    socket.on("connect_error", (error) => {
      console.error("❌ Connection error:", error.message);

      if (callbacks.onError) {
        callbacks.onError(error);
      }
    });

    // Live incoming messages
    socket.on("message", (msg) => {
      console.log("📨 Received message:", {
        message_id: msg.message_id,
        client_message_id: msg.client_message_id,
        sender_id: msg.sender_id,
      });

      roomCallbacks.current[roomname]?.onMessage?.(msg);
    });

    // History messages
    socket.on("history_message", (msg) => {
      console.log("📜 History message:", msg.message_id);
      roomCallbacks.current[roomname]?.onMessage?.(msg);
    });

    // History complete
    socket.on("history_complete", (data) => {
      console.log("📘 History complete:", data.count, "messages");
      roomCallbacks.current[roomname]?.onHistoryComplete?.(data);
    });

    // Message failed
    socket.on("message_failed", (err) => {
      console.error("❌ Message failed:", err);
      roomCallbacks.current[roomname]?.onMessageFailed?.(err);
    });

    // Server errors
    socket.on("error", (err) => {
      console.error("❌ Server error:", err);
      if (callbacks.onError) {
        callbacks.onError(err);
      }
    });
  };

  // ------------------------------------------------------------
  // CLOSE / LEAVE ROOM
  // ------------------------------------------------------------
  const closeConnection = (roomKey, studentId) => {
    if (!roomKey || !studentId) return;

    const roomname = `${roomKey}_${studentId}`;
    const socket = sockets.current[roomname];

    if (!socket) return;

    console.log("🚪 Closing socket:", roomname);

    socket.removeAllListeners();
    socket.disconnect();

    delete sockets.current[roomname];
    delete roomCallbacks.current[roomname];
  };

  // ------------------------------------------------------------
  // SEND MESSAGE
  // ------------------------------------------------------------
  const sendMessage = (roomKey, studentId, payload) => {
    const roomname = `${roomKey}_${studentId}`;
    const socket = sockets.current[roomname];

    if (!socket || !socket.connected) {
      console.error("❌ Cannot send, socket not connected:", roomname);
      return;
    }

    const data = {
      ...payload,
      roomname,
    };

    console.log("📤 Sending message:", {
      roomname,
      client_message_id: data.client_message_id,
      message: data.message?.substring(0, 50) + "...",
    });

    socket.emit("send_message", data);
  };

  // ------------------------------------------------------------
  // GET CONNECTION STATE
  // ------------------------------------------------------------
  const getConnectionState = (roomKey, studentId) => {
    if (!roomKey || !studentId) {
      return { status: "disconnected" };
    }

    const roomname = `${roomKey}_${studentId}`;
    const socket = sockets.current[roomname];

    if (!socket) {
      return { status: "disconnected" };
    }

    if (socket.connected) {
      return { status: "connected" };
    }

    if (socket.connecting) {
      return { status: "connecting" };
    }

    return { status: "disconnected" };
  };

  // ------------------------------------------------------------
  // CLEANUP ON UNMOUNT
  // ------------------------------------------------------------
  useEffect(() => {
    return () => {
      Object.keys(sockets.current).forEach((roomname) => {
        const socket = sockets.current[roomname];
        if (socket) {
          socket.removeAllListeners();
          socket.disconnect();
        }
      });

      sockets.current = {};
      roomCallbacks.current = {};
    };
  }, []);

  return (
    <WebSocketContext.Provider
      value={{
        createConnection,
        closeConnection,
        sendMessage,
        getConnectionState,
      }}
    >
      {children}
    </WebSocketContext.Provider>
  );
}
